import React from 'react'
import { useNavigate } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import api from '../../config/axions.config';
import { toast } from 'sonner';
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { RiArrowDropDownLine } from "react-icons/ri";
import { utils, writeFile } from 'xlsx';

const CustomReports = () => {
  const [admissionTypeList, setAdmissionTypeList] = useState([])
  const [courseList, setCourseList] = useState([])
  const [payment_typeList, setPayment_typeList] = useState([]);
  const [collageList, setCollageList] = useState([]);
  const [tutorList, setTutorList] = useState([]);

  const [admission_type, setAdmission_type] = useState('')
  const [course_id, setCourse_id] = useState('')
  const [payment_type, setPayment_type] = useState('');
  const [collage_id, setCollage_id] = useState('');
  const [tutor, setTutor] = useState('');
  const [customReportData, setCustomReportData] = useState([]); // State to store report data

  // helper  functions
  async function getCollegList() {
    try {
      let responce = await api.get("collage")
      if (responce?.data.status) {
        setCollageList(responce.data.data.colleges);
      } else {
        toast.error(responce.data.message)
      }
    } catch (error) {
      console.log(error);
    }
  }
  async function getPaymentType() {
    try {
      let responce = await api.get("paymentType")
      if (responce?.data.status) {
        setPayment_typeList(responce.data.data.PaymentTypes);
      } else {
        toast.error(responce.data.message)
      }
    } catch (error) {
      console.log(error);
    }
  }
  async function getCourseList() {
    try {
      let responce = await api.get("course")
      if (responce?.data.status) {
        setCourseList(responce.data.data.courses);
      } else {
        toast.error(responce.data.message)
      }
    } catch (error) {
      console.log(error);
    }
  }
  async function getAdmissionType() {
    try {
      let responce = await api.get("admissionType")
      if (responce?.data.status) {
        setAdmissionTypeList(responce.data.data.AdmissionTypes);
      } else {
        toast.error(responce.data.message)
      }
    } catch (error) {
      console.log(error);
    }
  }
  async function getTutor() {
    try {
      let responce = await api.get("staff")
      if (responce?.data.status) {
        setTutorList(responce.data.data.Tutor);
      } else {
        toast.error(responce.data.message)
      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    getCourseList();
    getAdmissionType();
    getPaymentType();
    getCollegList();
    getTutor()
  }, [])

  const inputRefDate = useRef();
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;

  const onClickCustom = () => {
    inputRefDate.current.click();
  }

  /* For Course Selection */
  const [isOpen, setIsOpen] = useState(false);
  const [selectedCourses, setSelectedCourses] = useState([]);
  const dropdownRef = useRef(null);

  // Toggle dropdown open/close
  const toggleDropdown = () => setIsOpen(!isOpen);

  // Handle checkbox selection
  const handleCheckboxChange = (courseId) => {
    let updatedSelection;
    if (selectedCourses.includes(courseId)) {
      updatedSelection = selectedCourses.filter((id) => id !== courseId);
    } else {
      updatedSelection = [...selectedCourses, courseId];
    }
    setSelectedCourses(updatedSelection);
    setCourse_id(updatedSelection); // Update parent state
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }; document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);



  /* For Admission Type Selection */
  const [isAdmissionTypeOpen, setIsAdmissionTypeOpen] = useState(false);
  const [selectedAdmissionType, setSelectedAdmissionType] = useState([]);
  const dropdownAdmissionTypeRef = useRef(null);

  // Toggle dropdown open/close
  const toggleDropdownAdmissionType = () => setIsAdmissionTypeOpen(!isAdmissionTypeOpen);

  // Handle checkbox selection
  const handleCheckboxChangeAdmissionType = (admission_type) => {
    let updatedSelection;
    if (selectedAdmissionType.includes(admission_type)) {
      updatedSelection = selectedAdmissionType.filter((id) => id !== admission_type);
    } else {
      updatedSelection = [...selectedAdmissionType, admission_type];
    }
    setSelectedAdmissionType(updatedSelection);
    setAdmission_type(updatedSelection); // Update parent state
  };

  useEffect(() => {
    const handleClickOutsideAdmissionType = (event) => {
      if (dropdownAdmissionTypeRef.current && !dropdownAdmissionTypeRef.current.contains(event.target)) {
        setIsAdmissionTypeOpen(false);
      }
    }; document.addEventListener("mousedown", handleClickOutsideAdmissionType);
    return () => document.removeEventListener("mousedown", handleClickOutsideAdmissionType);
  }, []);

  /* For College Selection */
  const [isCollegeOpen, setIsCollegeOpen] = useState(false);
  const [selectedColleges, setSelectedColleges] = useState([]);
  const dropdownCollegeRef = useRef(null);

  // Toggle dropdown open/close
  const toggleDropdownCollege = () => setIsCollegeOpen(!isCollegeOpen);

  // Handle checkbox selection
  const handleCheckboxChangeCollege = (collage_id) => {
    let updatedSelection;
    if (selectedColleges.includes(collage_id)) {
      updatedSelection = selectedColleges.filter((id) => id !== collage_id);
    } else {
      updatedSelection = [...selectedColleges, collage_id];
    }
    setSelectedColleges(updatedSelection);
    setCollage_id(updatedSelection); // Update parent state
  };

  useEffect(() => {
    const handleClickOutsideCollege = (event) => {
      if (dropdownCollegeRef.current && !dropdownCollegeRef.current.contains(event.target)) {
        setIsCollegeOpen(false);
      }
    }; document.addEventListener("mousedown", handleClickOutsideCollege);
    return () => document.removeEventListener("mousedown", handleClickOutsideCollege);
  }, []);


  /* For Payment Type Selection */
  const [isPaymentTypeOpen, setIsPaymentTypeOpen] = useState(false);
  const [selectedPaymentType, setSelectedPaymentType] = useState([]);
  const dropdownPaymentTypeRef = useRef(null);

  // Toggle dropdown open/close
  const toggleDropdownPaymentType = () => setIsPaymentTypeOpen(!isPaymentTypeOpen);

  // Handle checkbox selection
  const handleCheckboxChangePaymentType = (payment_type) => {
    let updatedSelection;
    if (selectedPaymentType.includes(payment_type)) {
      updatedSelection = selectedPaymentType.filter((id) => id !== payment_type);
    } else {
      updatedSelection = [...selectedPaymentType, payment_type];
    }
    setSelectedPaymentType(updatedSelection);
    setPayment_type(updatedSelection); // Update parent state
  };

  useEffect(() => {
    const handleClickOutsidePaymentType = (event) => {
      if (dropdownPaymentTypeRef.current && !dropdownPaymentTypeRef.current.contains(event.target)) {
        setIsPaymentTypeOpen(false);
      }
    }; document.addEventListener("mousedown", handleClickOutsidePaymentType);
    return () => document.removeEventListener("mousedown", handleClickOutsidePaymentType);
  }, []);


  /* For Tutor Selection */
  const [isTutorOpen, setIsTutorOpen] = useState(false);
  const [selectedTutor, setSelectedTutor] = useState([]);
  const dropdownTutorRef = useRef(null);

  // Toggle dropdown open/close
  const toggleDropdownTutor = () => setIsTutorOpen(!isTutorOpen);

  // Handle checkbox selection
  const handleCheckboxChangeTutor = (tutor) => {
    let updatedSelection;
    if (selectedTutor.includes(tutor)) {
      updatedSelection = selectedTutor.filter((id) => id !== tutor);
    } else {
      updatedSelection = [...selectedTutor, tutor];
    }
    setSelectedTutor(updatedSelection);
    setTutor(updatedSelection); // Update parent state
  };

  // pagination

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(8);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = customReportData?.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(customReportData.length / itemsPerPage);

  // **Page Change Handler**
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // get report api
  const getCustomReoprt = async () => {
    const body = {
      date : dateRange,
      status: true,
      collages: selectedColleges,
      streams: [], // Add logic to populate streams if needed
      courses: selectedCourses,
      admissionTypes: selectedAdmissionType,
    };

    try {
      const response = await api.post("student/student_report", body);
      if (response?.data?.status) {
        setCustomReportData(response.data.data?.students); // Update state with fetched data
        toast.success("Report fetched successfully!");
      } else {
        toast.error(response?.data?.message || "Failed to fetch report.");
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong, report not fetched.");
    }
  };
  
  // export csv
  function handleExportCSV() {
    if (!customReportData || customReportData.length === 0) {
      alert("No data available for export!");
      return;
  }
    // Convert data into an array of objects for Excel
    const excelData = customReportData.map((item) => ({
      "Student Id": item._id,
      "Name": `${item.firstname} ${item.lastname}`,
      "Contact": item.mobile,
      "Father's Contact": item.parent_mobile,
      "Email": item.email,
      "Admission Type": item.enrollmentsData.map(enr => enr.admissionDetail?.type || "").join(" | "),
      "Course": item.enrollmentsData.map(enr => enr.courseDetail?.name || "").join(" | "),
      "College": item.collage_info?.name || "N/A",
      "Stream": item.stream_info?.name || "N/A",
      "Total Fees": item.totalFee || 0,
      "Paid Fees": item.totalFeePaid || 0,
      "Installments": item.enrollmentsData.map(enr => enr.feeRecords.length).join(" | "),
      "Remaining Fees": item.remainingFee || 0
  }));

    const workBook = utils.book_new();
    const ws = utils.json_to_sheet(excelData); // Use customReportData for export
    utils.book_append_sheet(workBook, ws, "CustomReport");
    const timestamp = new Date().toISOString().split("T")[0]; // Generate timestamp
    writeFile(workBook, `Custom_Report_${timestamp}.csv`); // Dynamic filename
  }
  useEffect(() => {
    getCustomReoprt();
    const handleClickOutsideTutor = (event) => {
      if (dropdownTutorRef.current && !dropdownTutorRef.current.contains(event.target)) {
        setIsTutorOpen(false);
      }
    }; document.addEventListener("mousedown", handleClickOutsideTutor);
    return () => document.removeEventListener("mousedown", handleClickOutsideTutor);
  }, []);
  return (
    <div>
      <div className='grow ms-0 md:ms-0 lg:ms-56'>
        <div className="px-4 mt-6 mb-8 sm:px-6 lg:px-8">
          <div className='flex items-center justify-end lg:justify-between'>
            <h1 className="hidden text-2xl font-semibold text-primary-600 lg:block">
              Custom Reports
            </h1>
          </div>

          <div className="space-y-6 lg:mt-6">
            <div className="overflow-hidden bg-white rounded-lg shadow">
              <div className="px-4 py-5 sm:px-6">
                <div className="flex justify-between">
                  <div className='flex space-x-5'>

                  <div className="flex items-center space-x-2" ref={dropdownAdmissionTypeRef}>
                      <button
                        onClick={toggleDropdownAdmissionType}
                        className="w-full px-4 py-2 border rounded-md bg-white flex items-center justify-between"
                      >
                        {selectedAdmissionType.length > 0
                          ? `Select (${selectedAdmissionType.length})`
                          : "Admission Type"}&nbsp;&nbsp;
                        <RiArrowDropDownLine />
                      </button>

                      {isAdmissionTypeOpen && (
                        <div className="absolute mt-40 bg-white border rounded-md shadow-lg z-10">
                          <div className="p-2 max-h-40 overflow-y-auto">
                            {admissionTypeList?.map((item) => (
                              <label
                                key={item._id}
                                className="flex !font-normal !text-base items-center space-x-2 p-1 cursor-pointer hover:bg-gray-100"
                              >
                                <input
                                  type="checkbox"
                                  value={item._id}
                                  checked={selectedAdmissionType.includes(item._id)}
                                  onChange={() => handleCheckboxChangeAdmissionType(item._id)}
                                />
                                <span>{item.type}</span>
                              </label>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="flex items-center space-x-2" ref={dropdownRef}>
                      <button
                        onClick={toggleDropdown}
                        className="w-full px-4 py-2 border rounded-md bg-white flex items-center justify-between"
                      >
                        {selectedCourses.length > 0
                          ? `Select (${selectedCourses.length})`
                          : "Course"}&nbsp;&nbsp;
                        <RiArrowDropDownLine />
                      </button>

                      {isOpen && (
                        <div className="absolute mt-56 bg-white border rounded-md shadow-lg z-10">
                          <div className="p-2 max-h-44 overflow-y-auto">
                            {courseList?.filter(item=> item.admissionType === selectedAdmissionType.find((element)=>  element === item.admissionType) ).map((item) => (
                              <label
                                key={item._id}
                                className="flex !font-normal !text-base items-center space-x-2 p-1 cursor-pointer hover:bg-gray-100"
                              >
                                <input
                                  type="checkbox"
                                  value={item._id}
                                  checked={selectedCourses.includes(item._id)}
                                  onChange={() => handleCheckboxChange(item._id)}
                                />
                                <span>{item.name}</span>
                              </label>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="flex items-center space-x-2" ref={dropdownCollegeRef}>
                      <button
                        onClick={toggleDropdownCollege}
                        className="w-full px-4 py-2 border rounded-md bg-white flex items-center justify-between"
                      >
                        {selectedColleges.length > 0
                          ? `Select (${selectedColleges.length})`
                          : "College"}&nbsp;&nbsp;
                        <RiArrowDropDownLine />
                      </button>

                      {isCollegeOpen && (
                        <div className="absolute mt-56 bg-white border rounded-md shadow-lg z-10">
                          <div className="p-2 max-h-44 overflow-y-auto">
                            {collageList?.map((item) => (
                              <label
                                key={item._id}
                                className="flex !font-normal !text-base items-center space-x-2 p-1 cursor-pointer hover:bg-gray-100"
                              >
                                <input
                                  type="checkbox"
                                  value={item._id}
                                  checked={selectedColleges.includes(item._id)}
                                  onChange={() => handleCheckboxChangeCollege(item._id)}
                                />
                                <span>{item.name}</span>
                              </label>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="flex items-center space-x-2" ref={dropdownPaymentTypeRef}>
                      <button
                        onClick={toggleDropdownPaymentType}
                        className="w-full px-4 py-2 border rounded-md bg-white flex items-center justify-between"
                      >
                        {selectedPaymentType.length > 0
                          ? `Select (${selectedPaymentType.length})`
                          : "Payment Type"}&nbsp;&nbsp;
                        <RiArrowDropDownLine />
                      </button>

                      {isPaymentTypeOpen && (
                        <div className="absolute mt-64 bg-white border rounded-md shadow-lg z-10">
                          <div className="p-2 max-h-50 overflow-y-auto">
                            {payment_typeList?.map((item) => (
                              <label
                                key={item._id}
                                className="flex !font-normal !text-base items-center space-x-2 p-1 cursor-pointer hover:bg-gray-100"
                              >
                                <input
                                  type="checkbox"
                                  value={item._id}
                                  checked={selectedPaymentType.includes(item._id)}
                                  onChange={() => handleCheckboxChangePaymentType(item._id)}
                                />
                                <span>{item.type}</span>
                              </label>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="flex items-center space-x-2" ref={dropdownTutorRef}>
                      <button
                        onClick={toggleDropdownTutor}
                        className="w-full px-4 py-2 border rounded-md bg-white flex items-center justify-between"
                      >
                        {selectedTutor.length > 0
                          ? `Select (${selectedTutor.length})`
                          : "Tutor"}&nbsp;&nbsp;
                        <RiArrowDropDownLine />
                      </button>

                      {isTutorOpen && (
                        <div className="absolute mt-24 bg-white border rounded-md shadow-lg z-10">
                          <div className="p-2 max-h-50 overflow-y-auto">
                            {tutorList?.map((item) => (
                              <label
                                key={item._id}
                                className="flex !font-normal !text-base items-center space-x-2 p-1 cursor-pointer hover:bg-gray-100"
                              >
                                <input
                                  type="checkbox"
                                  value={item._id}
                                  checked={selectedTutor.includes(item._id)}
                                  onChange={() => handleCheckboxChangeTutor(item._id)}
                                />
                                <span>{item.firstname + " " + item.lastname}</span>
                              </label>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="flex items-center ml-8 space-x-2">
                      <DatePicker
                        selectsRange={true}
                        ref={inputRefDate}
                        startDate={startDate}
                        dateFormat="dd/MM/yyyy"
                        endDate={endDate}
                        onChange={(update) => {
                          setDateRange(update);
                        }}
                        isClearable={true}
                        placeholderText="Custom Date"
                      />
                    </div>
                  </div>
                  <div className='flex space-5'>
                    <div className='px-2 pr-2'>
                      <button onClick={getCustomReoprt} className='btn btn-primary'>
                        Search
                      </button>
                    </div>
                    <div className='px-2 pr-2'>
                      <button onClick={handleExportCSV} className='btn btn-primary'>
                        <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M19 15V17C19 18.1046 18.1046 19 17 19H7C5.89543 19 5 18.1046 5 17V15M12 5V15M12 15L10 13M12 15L14 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        Download
                      </button>
                    </div>
                  </div>
                </div>

              </div>

              <div className="flex flex-col">
                <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                  <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                    <div className="overflow-hidden">
                      <table className="custom-table">
                        <thead>
                          <tr>
                            <th scope="col" className="hidden xl:table-cell">
                              Student Id
                            </th>
                            <th scope="col">
                              Name
                            </th>
                            <th scope="col">
                              Contact
                            </th>
                            <th scope="col">
                              Father's Contact
                            </th>
                            <th scope="col">
                              Email
                            </th>
                            <th scope="col">
                              Admission Type
                            </th>
                            <th scope="col">
                              Course
                            </th>
                            <th scope="col">
                              College
                            </th>
                            <th scope="col">
                              Stream
                            </th>
                            <th scope="col">
                              Fees
                            </th>
                            <th scope="col">
                              Paid Fee
                            </th>
                            <th scope="col">
                              Installments
                            </th>
                            <th scope="col">
                              Remaining Fees
                            </th>
                          </tr>
                        </thead>

                        <tbody>
                          { currentItems?.map(item => < tr key={item._id} >
                            <td >
                              <div className="flex items-center">
                                <div className="flex-1 min-w-0 ml-2">
                                  <div title="" className="font-medium truncate hover:text-primary-600 w-36 sm:w-auto line-clamp-1">
                                    {item._id}
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td className="whitespace-nowrap">
                              {item.firstname + " " + item.lastname}
                            </td>
                            <td className="whitespace-nowrap">
                              {item.mobile}
                            </td>
                            <td className="whitespace-nowrap">
                              {item.parent_mobile}
                            </td>
                            <td className="whitespace-nowrap">
                              {item.email}
                            </td>
                            <td className="whitespace-nowrap">
                            {
                                item.enrollmentsData.map(item=> `${item.admissionDetail.type} |  `)
                              }
                            </td>
                            <td className="whitespace-nowrap">
                              {
                                item.enrollmentsData.map(item=> `${item.courseDetail?.name} |  `)
                              }
                            </td>
                            <td className="whitespace-nowrap">
                              {item.collage_info.name}
                            </td>
                            <td className="whitespace-nowrap">
                              {item.stream_info.name}
                            </td>
                            <td className="whitespace-nowrap">
                              {
                                item.totalFee
                              }
                            </td>
                            <td className="whitespace-nowrap">
                              {
                                item.totalFeePaid
                              }
                            </td>
                            <td className="whitespace-nowrap">
                              {/* {Array.isArray(item.enrollmentsData) ? " Array" : "not an array" } */}
                              {
                                item.enrollmentsData.map((data)=> data.feeRecords.length + " | ")
                              }
                            </td>
                            <td className="whitespace-nowrap">
                              {
                                item.remainingFee
                              }
                            </td>
                          </tr>)}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div className="px-4 py-5 bg-white border-t border-gray-200 sm:px-6">
                <div className="px-4 bg-white border-gray-200">
                  <div className="flex justify-between items-center">
                    <div>
                      <p className="text-sm text-gray-700">
                        Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, customReportData.length)} of {customReportData.length} results
                      </p>
                    </div>
                    <div className='flex space-x-5'>
                      <div className="flex items-center ml-8 space-x-2">
                        <span>
                          Show
                        </span>
                        <select onChange={(e) => setItemsPerPage(e.target.value)}>
                          <option value="10">
                            10
                          </option>
                          <option value="7">
                            7
                          </option>
                          <option value="5">
                            5
                          </option>
                        </select>
                        <span>
                          records
                        </span>
                      </div>
                      <div className="flex">
                        {/* Previous Button */}
                        <button
                          onClick={() => handlePageChange(currentPage - 1)}
                          disabled={currentPage === 1}
                          className={`inline-flex items-center px-2 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-l-lg hover:bg-gray-50 ${currentPage === 1 ? 'text-gray-400' : 'text-black'}`}
                        >
                          <svg className="w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" />
                          </svg>
                        </button>

                        {/* Page Numbers */}
                        {[...Array(totalPages).keys()].map((num) => {
                          const pageNumber = num + 1;

                          // Calculate the first and last pages to show
                          const firstPageToShow = Math.max(1, currentPage - 1);  // Show 1 page before current (if possible)
                          const lastPageToShow = Math.min(totalPages, currentPage + 1);  // Show 1 page after current (if possible)

                          // Only show page numbers within the calculated range
                          if (pageNumber >= firstPageToShow && pageNumber <= lastPageToShow) {
                            return (
                              <button
                                key={pageNumber}
                                onClick={() => handlePageChange(pageNumber)}
                                className={`inline-flex items-center px-4 py-2 text-sm font-medium border text-gray-500 ${currentPage === pageNumber ? 'bg-primary-100 border-primary-600 text-primary-600' : 'text-black'}`}
                              >
                                {pageNumber}
                              </button>
                            );
                          }
                          return null;  // Skip rendering page numbers outside of the range
                        })}

                        {/* Next Button */}
                        <button
                          onClick={() => handlePageChange(currentPage + 1)}
                          disabled={currentPage === totalPages}
                          className={`inline-flex items-center px-2 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-r-lg hover:bg-gray-50 ${currentPage === totalPages ? 'text-gray-400' : 'text-black'}`}
                        >
                          <svg className="w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CustomReports
